<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="150px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="storageId" label="存油记录">
              {{ formData.storageId || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="contractAmount" label="合同金额(元)">
              {{ formData.contractAmount || "0" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="userName" label="客户名称">
              {{ formData.userName || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="specName" label="品种规格">
              {{ formData.specName || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="quantity" label="存油数量">
              {{ formData.quantity || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygCode" label="关联仓库">
              {{ formData.ygCode || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="startDate" label="开始计价日期">
              {{ formData.startDate || "" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="endDate" label="租赁到期时间">
              {{ formData.endDate || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="dailyRent" label="每日租金单价(元)">
              {{ formData.dailyRent || "0" }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="minimumPrice" label="每日最低收费(元)">
              {{ formData.minimumPrice || "0" }}
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 新增绩效系数 -->
        <el-row>
<!--          <el-col :span="12">-->
<!--            <el-form-item prop="jxRatio" label="绩效系数">-->
<!--              {{ formData.jxRatio || "0" }}-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer>
  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer.vue'

export default {
  name: 'rentManageDetail',
  components: { ImageViewer },
  data () {
    return {
      formData: {
        storageId: '',
        contractAmount: '',
        startDate: '',
        endDate: '',
        dailyRent: '',
        minimumPrice: '',
        jxRatio: '',
        fileList: []
      },
      loading: false,
      currentImageIndex: 0,
      dialogVisible: false
    }
  },
  created () {
    this.loadDict()
    if (this.storageId) {
      this.loadData()
    }
  },
  computed: {
    storageId () {
      return this.$route.query.storageId
    },
    formatFileList () {
      return this.formData.fileList.map(file => {
        return {
          name: file.fileName,
          url: file.filePrefix + file.fileUrl
        }
      })
    },
    imageList () {
      return this.formatFileList.filter(item => {
        console.log('item', item)
        return item.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(item.name.substring(item.name.lastIndexOf('.')).toLowerCase())
      })
    }
  },
  methods: {
    onPreview (file) {
      console.log('file', file)
      if (file.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())) {
        this.currentImageIndex = this.imageList.findIndex(url => url.name === file.name)
        this.dialogVisible = true
      } else {
        window.open(file.url, '_blank')
      }
    },
    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },
    beforeUpload (file) {
      const isLt50M = file.size < (50 * 1024 * 1024)
      if (!isLt50M) {
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      return isLt50M
    },
    loadDict () {
    },
    onDown(url) {
      window.open(url, '_blank')
    },
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.rentManage.selectYgnCustRentByStorageId, {
          params: { storageId: this.storageId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res || {}
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
.shoufa-form {
  width: 900px;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
